document.addEventListener("DOMContentLoaded", function () {
  const selectors = {
    dl: '[data-accordion="true"] dl',
    dt: "dt",
    table: "table",
    class: "is-open",
    animation: "is-animation",
  };
  const accordions = document.querySelectorAll(selectors.dl);
  accordions.forEach((accordion) => {
    const dts = accordion.querySelectorAll(selectors.dt);
    dts.forEach((dt) => {
      dt.addEventListener("click", () => {
        dt.classList.toggle(selectors.class);
      });
    });
  });
});
